<template>
  <div id="close">
    <div class="item button" @click="close">
      <span class="more uppercase nav nav_go nav_go_s nav_go_left">zurück</span>
    </div>
  </div>
  <div v-if="!isLoading" id="choose_images">
    <div class="item new_image">
      <form>
        <BaseInput v-model="image.name" label="Titel/Bildlegende" type="text" />
        <BaseInput v-model="image.caption" label="Quelle" type="text" />

        <input id="file" ref="file" type="file" @change="selectFile" />
        <label
          for="file"
          class="more uppercase nav nav_go nav_go_s nav_go_right"
          :class="{ white: !fileSelected }"
          >Bild auswählen</label
        >
      </form>
      <span
        class="more uppercase nav nav_go nav_go_s nav_go_right"
        :class="{ white: fileSelected }"
        @click="uploadImage"
        >Hochladen</span
      >
    </div>
    <img
      v-for="i in images"
      :key="i.id"
      class="select"
      :src="
        $store.state.connection + '/storage/images/' + i.link_name + '_200.jpg'
      "
      @click="setImage(i.id, i.link_name)"
    />
  </div>
</template>

<script>
import axios from "axios";
import BaseInput from "../components/BaseInput";

export default {
  components: { BaseInput },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  emits: ["set-image", "close"],
  data() {
    return {
      images: [],
      image: {
        name: "",
        caption: "",
        type: this.type
      },
      isLoading: true,
      fileSelected: false,
      file: null
    };
  },
  created() {
    this.getImages();
  },
  methods: {
    getImages() {
      axios
        .get(this.$store.state.connection + "/api/getImages/" + this.type)
        .then(({ data }) => {
          this.images = data;
          this.isLoading = false;
        });
    },
    uploadImage() {
      let formData = new FormData();
      //  let file = e.target.files[0];
      let file = this.$refs.file.files[0];
      formData.append("image", file);
      for (let k in this.image) {
        formData.append(k, this.image[k]);
      }
      //TODO: move to store
      axios
        .post(this.$store.state.connection + "/api/uploadImage", formData)
        .then(({ data }) => {
          //console.log(data.id + ' ' + data.link_name);
          this.setImage(data.id, data.link_name);
        });
    },
    setImage(id, link) {
      this.$emit("set-image", { id, link });
    },
    close() {
      this.$emit("close");
    },
    selectFile() {
      this.fileSelected = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../scss/_variables.scss";
@import "../scss/_admin.scss";
#choose_images {
  top: 15rem;
  position: fixed;
  height: 100%;
  width: 100%;
  background: $rainbow_0;
  display: flex;
  flex-direction: row;
  align-content: baseline;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow: scroll;
  padding: 1rem;
  padding-top: 10rem;
}
.select {
  height: 30rem;
  width: auto;
  margin: 1rem;
  cursor: pointer;
}
.new_image {
  max-height: 26rem;
  width: 40rem;
  margin: 1rem;
}
.submit {
  font-size: 2rem;
  cursor: pointer;
}
.new_image > .more,
.new_image > form > .more {
  margin: 1rem 0;
}
.new_image > .more.white,
.new_image > form > .more.white {
  color: white;
}
.new_image > .more {
  margin: 2rem 0;
}
.new_image > .more::before,
.new_image > form > .more::before {
  background: $mainBlue;
}
.new_image > .more.white::before,
.new_image > form > .more.white::before {
  background: white;
}
[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

[type="file"] + label {
  /* File upload button styles */
}

[type="file"]:focus + label,
[type="file"] + label:hover {
  /* File upload hover state button styles */
}

[type="file"]:focus + label {
  /* File upload focus state button styles */
}
</style>
